/*
 * @Author: zys22 226208335@qq.com
 * @Date: 2025-10-10 09:59:43
 * @LastEditors: zys22 226208335@qq.com
 * @LastEditTime: 2026-10-14 09:49:40
 * @FilePath: /frasergen-weixin-web/src/pages/Layout/layout.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { CapsuleTabs, Button } from 'antd-mobile'
import { Outlet, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useStore } from '@/store'

import './index.scss'

const Layout = () => {
  const store = useStore()
  const { loginStore } = store
  const navigate = useNavigate()
  const onChangeTabs = (tab) => {
    if (tab === 'logout') {
      loginStore.outLogin()
      navigate('/login')
      return
    }
    store.lontractManagementStore.setpage(0)
    store.InvoiceManagementStore.setpage(0)
    store.PaymentCollectionStore.setpage(0)
    store.PaymentTransferStore.setpage(0)
    store.lontractProgressStore.setpage(0)
    navigate(tab)
  }
  return (
    <div>

      <CapsuleTabs defaultActiveKey='' onChange={onChangeTabs}>
        <CapsuleTabs.Tab title='合同查询' key='contract_management'>
          <div className='tab-main'>
            <Outlet />
          </div>

        </CapsuleTabs.Tab>
        <CapsuleTabs.Tab title='发票查询' key='invoice_management'>
          <div className='tab-main'>
            <Outlet />
          </div>

        </CapsuleTabs.Tab>
        <CapsuleTabs.Tab title='回款查询' key='payment_collection'>
          <div className='tab-main'>
            <Outlet />
          </div>

        </CapsuleTabs.Tab>
        <CapsuleTabs.Tab title='转款查询' key='payment_transfer'>
          <div className='tab-main'>
            <Outlet />
          </div>

        </CapsuleTabs.Tab>
        <CapsuleTabs.Tab title='项目进度' key='contract_progress'>
          <div className='tab-main'>
            <Outlet />
          </div>
        </CapsuleTabs.Tab>
        <CapsuleTabs.Tab title='退出登录' key='logout' />



      </CapsuleTabs>


    </div>
  )
}

export default observer(Layout)